import React, { useState, useEffect } from "react";
import "./Navbar.css"; // Ensure Tailwind CSS is applied
import SearchBar from "./SearchBar";
import { useNavigate } from "react-router-dom";


const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  
  const [isAuthorized, setIsAuthorized] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthorization = () => {
      const token = localStorage.getItem("access_token");
  
      if (token) {
          setIsAuthorized(true);
      } else {
          setIsAuthorized(false);
      }
  };

    checkAuthorization();
  }, []);
  

  return (
    <>
      <nav className="bg-white border-gray-200 dark:bg-gray-900 transition-all duration-300">
        <div className="max-w-screen-xl mx-auto px-4 py-3 flex justify-between items-center">
          <a href="#self-introduction" className="flex items-center space-x-2">
            <span className="self-center text-2xl font-semibold whitespace-nowrap text-gray-900 dark:text-yellow-400">
              Xu's Portfolio
            </span>
          </a>

          <div className="hidden md:flex space-x-6">
            <a href="#experience" className="text-gray-900 dark:text-gray-300 hover:text-yellow-500 dark:hover:text-yellow-400">
              Experience
            </a>
            <a href="#education-certifications" className="text-gray-900 dark:text-gray-300 hover:text-yellow-500 dark:hover:text-yellow-400">
              Education
            </a>
            <a href="#os-visit-graph" className="text-gray-900 dark:text-gray-300 hover:text-yellow-500 dark:hover:text-yellow-400">
              Data
            </a>
            <a href="#time-zones-world-map" className="text-gray-900 dark:text-gray-300 hover:text-yellow-500 dark:hover:text-yellow-400">
              Server
            </a>
            <a href="#about-me" className="text-gray-900 dark:text-gray-300 hover:text-yellow-500 dark:hover:text-yellow-400">
              About
            </a>
            <a href="#contact" className="text-gray-900 dark:text-gray-300 hover:text-yellow-500 dark:hover:text-yellow-400">
              Contact
            </a>
          </div>

          <div className="flex space-x-4">
            {isAuthorized ? (
            <button
              onClick={() => navigate("/user")}
              className="text-white bg-green-600 hover:bg-green-700 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:bg-green-500 dark:hover:bg-green-600 dark:focus:ring-green-400"
            >
              User Page
            </button>
          ) : (
            <a
              href="/auth"
              className="text-blue-900 bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:text-gray-900 dark:bg-yellow-400 dark:hover:bg-yellow-500 dark:focus:ring-yellow-300"
            >
              Login
            </a>
          )}
            <button
              onClick={toggleMobileMenu}
              type="button"
              className="md:hidden text-gray-400 hover:text-gray-900 dark:hover:text-white focus:outline-none focus:ring-2 focus:ring-gray-200 dark:focus:ring-gray-600"
              aria-controls="mobile-menu"
              aria-expanded={isMobileMenuOpen}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`${isMobileMenuOpen ? "block" : "hidden"} md:hidden`} id="mobile-menu">
          <ul className="bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-300 space-y-2 py-2 px-4">
            <li>
              <a href="#self-introduction" className="block py-2 px-3 hover:bg-gray-200 dark:hover:bg-gray-700 rounded">
                Home
              </a>
            </li>
            <li>
              <a href="#experience" className="block py-2 px-3 hover:bg-gray-200 dark:hover:bg-gray-700 rounded">
                Experience
              </a>
            </li>
            <li>
              <a href="#education-certifications" className="block py-2 px-3 hover:bg-gray-200 dark:hover:bg-gray-700 rounded">
                Education
              </a>
            </li>
            <li>
              <a href="#os-visit-graph" className="block py-2 px-3 hover:bg-gray-200 dark:hover:bg-gray-700 rounded">
                OS & Visit
              </a>
            </li>
            <li>
              <a href="#time-zones-world-map" className="block py-2 px-3 hover:bg-gray-200 dark:hover:bg-gray-700 rounded">
                Map
              </a>
            </li>
            <li>
              <a href="#about-me" className="block py-2 px-3 hover:bg-gray-200 dark:hover:bg-gray-700 rounded">
                About
              </a>
            </li>
            <li>
              <a href="#contact" className="block py-2 px-3 hover:bg-gray-200 dark:hover:bg-gray-700 rounded">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <SearchBar />
    </>
  );
};

export default Navbar;
